import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=34bc7fba&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=js&"
export * from "./Cell.vue?vue&type=script&lang=js&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=34bc7fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc7fba",
  null
  
)

export default component.exports